export const CLASS_COLOR = 'color';
